import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

const StyledButton = styled(Button)({});
StyledButton.defaultProps = { variant: "contained", color: "secondary" };

export default StyledButton as typeof Button;
